import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
// import Francois from './components/Francois';

import Header from './components/Header';
import PageAccueil from './components/PageAccueil';
import AskList from './components/AskList';
import Tutorial from './components/Tutorial';
import TutoAccueil from './components/TutoAccueil';
import TutoDetails from './components/TutoPrePageDetails';
import Contact from './components/Contact';
import Footer from './components/Footer';

import './App.scss';

const App = function App() {
  return (
    <div className="App">
      {/* Auto scroll to top when page change */}
      <ScrollToTop />

      {/* Header */}
      <Header />

      {/* Route - Main */}
      <Routes>
        {/* Home */}
        <Route exact path="/" element={<PageAccueil />} />

        {/* Allo Mano */}
        <Route exact path="/allomano" element={<AskList />} />

        {/* Alla Mano */}
        <Route exact path="/allamano" element={<TutoAccueil />} />
        <Route exact path="/allamano/:slug" element={<TutoDetails />} />
        <Route exact path="/allamano/:slug/:page" element={<Tutorial />} />
        <Route exact path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </div>
  );
};

export default App;
